export default "__VITE_ASSET__Do2_0P19__"